import { FC } from "react"
import { DatePeriodPanel } from "../../../../hoc/DatePeriodPanel/DatePeriodPanel"
import { IDatePeriod } from "../../../../components/datePeriodPicker/datePeriodPicker"
import { GridFilterAction } from "../../../../system/hooks/useGridFilter"
import { useTranslation } from "react-i18next"
import { SearchButtonPanel } from "../../../../components/buttons/iconButtons/action/MainCollection"
import styles from './../../../../components/commandsPanels/styles/BaseCommandsPanel.module.scss'
import Tooltip from "../../../../components/tooltips/Tooltip"
import { RotationRightButton } from "../../../../components/buttons/iconButtons/action/RotationCollection"

interface IPanelEvent {
    disabled?: boolean
    onClick: () => any    
    onSubItemClick?: () => any
}

interface ILotMovementPanelProps {
    search?: IPanelEvent 
    permission?: IPermission
    dispatchGridFilter: (value: GridFilterAction) => void
    datePeriod: IDatePeriod
    onDatePeriodChange: (datePeriod: IDatePeriod) => void
    onFocusChanged?: (taken: boolean) => void;
    refresh?: IPanelEvent;
    onClickOnSearchButton: () => void;
    onClickRefresh: () => void;
    hasActiveFilters?: boolean
}


export const LotMovementPanel: FC<ILotMovementPanelProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t('documentsCommandsPanel.' + value)

    return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Tooltip title={baseT('search')}>            
            <div className={styles.searchField_SearchIcon}  style={props.hasActiveFilters ? { backgroundColor: 'rgb(153, 204, 255)', borderRadius: "2px" } : {}}>
                <SearchButtonPanel sizeVariant="mini" onClick={() => props.onClickOnSearchButton()} />
            </div>
        </Tooltip>
        <Tooltip title={baseT('refresh')}>
            <RotationRightButton sizeVariant="mini" onClick={() => props.onClickRefresh()} />
        </Tooltip>
        <DatePeriodPanel
            datePeriod={props.datePeriod}
            onDatePeriodChange={(date: IDatePeriod) => {
                props.onDatePeriodChange(date);
            }}
        />
    </div>)

}
